import Vue from 'vue'
import Router from 'vue-router'
// import Login from '@/views/Login'

// import Redirect from '@/views/Redirect'

Vue.use(Router)

// 解决报错：Redirected when going from "X" to "X" via a navigation guard.
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject){
		return originalPush.call(this, location, onResolve, onReject)
	}
	return originalPush.call(this, location).catch(err => err)
}

export const constantRouterMap = [
	// {
	// 	path: '/login',
	// 	name: '登录',
	// 	component: Login
	// },
	{
		path: '/',
		component: () => import('@/views/Home'),
		name:"index",
	},
	{
		path: '/index',
		component: () => import('@/views/Home'),
		name:"index",
	},
	{
		path: '/company',
		component: () => import('@/views/Company'),
		name:"company",
	},
	{
		path: '*',
		redirect: '/index',
	},


]

export default new Router({
	// mode: 'history', //后端支持可开
	scrollBehavior: () => ({ y: 0 }),
	routes: constantRouterMap
});
export const asyncRouterMap = [];



// WEBPACK FOOTER //
// ./src/router/index.js